<template>
  <!-- 对齐 App map：顶部 header + 全屏地图 + 右下浮动定位按钮 + 底部 Scan QR code 按钮 + shop-info 弹窗 -->
  <div class="map-page">
    <!-- 顶部 header：中 logo（返回按钮已移除，首页无上一页可返回；搜索在右下浮动） -->
    <div class="map-header" :style="{ paddingTop: safeArea.top + 'px' }">
      <img
        class="map-header-logo"
        src="../../assets/imgs/img_logo.png"
        alt=""
      />
    </div>

    <!-- 全屏 Google Map -->
    <div class="google-map">
      <google-map
        ref="gmap"
        :locationList="list"
        :latLng="latLng"
        @center="onCenter"
        @zoom="onZoom"
        @setItem="onSetItem"
        @onmap="show = false"
      />
    </div>

    <!-- 右下浮动：搜索按钮 + 定位按钮（对齐 App map.dart L273-302，搜索在上，定位在下） -->
    <div class="map-fab-search" @click="goSearch">
      <img src="../../assets/imgs/icon_search.png" alt="" />
    </div>
    <div class="map-fab-gps" @click="goLocation">
      <img src="../../assets/imgs/icon_locate.png" alt="" />
    </div>

    <!-- 底部导航（通用 BottomNav）：home 即本页（/map 主页）故高亮，中央 scan 派发事件由 goScan 处理登录态 -->
    <bottom-nav active="home" class="map-bottom-nav" @scan="goScan"></bottom-nav>

    <!-- shop-info 弹窗（点击地图 marker 时显示） -->
    <transition name="fade">
      <div v-if="item && show" class="shop-info">
        <div class="shop-info-head">
          <div class="shop-title">
            <h3>{{ item.shopName }}</h3>
            <span
              :class="[
                item.infoStatus === '在线' ? 'shop-tag-active' : '',
                'shop-tag'
              ]"
              >{{ i18n[item.infoStatus] }}</span
            >
          </div>
          <a @click="goDetail"
            ><img src="../../assets/imgs/popup_btn_navigation.png" alt=""
          /></a>
        </div>
        <div class="shop-info-content">
          <div class="shop-logo">
            <img v-if="item.shopBanner" :src="item.shopBanner" alt="" />
            <img v-else src="../../assets/imgs/banner-home.jpg" alt="" />
          </div>
          <div class="shop-detail">
            <div class="shop-time">
              <span class="time">
                <img src="../../assets/imgs/map.png" alt="" />
                {{ item.shopAddress1 }}
              </span>
              <span class="time">
                <img src="../../assets/imgs/distance.png" alt="" />
                {{ item.distance }}
              </span>
              <span class="time">
                <img src="../../assets/imgs/icon_time.png" alt="" />
                {{ item.shopTime }}
              </span>
            </div>
            <div class="shop-op">
              <span class="free-num"
                >{{ i18n.free }}：{{ item.freeNum }}</span
              >
              <span class="return-num"
                >{{ i18n.return }}：{{
                  Number(item.canReturnNum)
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 扫码组件（已登录调起） -->
    <div class="map-pickup" v-if="isPickUpShow" @click="isPickUpShow = false">
      <ScanQr @scanQr="onScanQr" @back="isPickUpShow = false" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import GoogleMap from "./google-map.vue"
import ScanQr from "@/views/scanQr/scanQr.vue"
import BottomNav from "@/components/common/BottomNav.vue"
import { debounce } from "../../utils/index"
import { SHOP_LIST, QR_CODE } from "../../apis/cabinet"
export default {
  components: {
    GoogleMap,
    ScanQr,
    BottomNav
  },
  data() {
    return {
      latLng: [22.631123, 113.820622],
      zoomLevel: "4",
      list: [],
      item: null,
      show: false,
      isPickUpShow: false
    }
  },
  computed: {
    ...mapState(["user", "token", "safeArea"]),
    i18n() {
      return this.$t("map")
    },
    i18nHome() {
      return this.$t("home")
    },
    i18nMsg() {
      return this.$t("msg")
    }
  },
  watch: {
    latLng() {
      this.lazyLoad(this)
    }
  },
  methods: {
    getNearbyShop() {
      this.$loading(true)
      this.$post(
        SHOP_LIST,
        {
          coordType: "WGS－84",
          lat: this.latLng[0],
          lng: this.latLng[1],
          zoomLevel: this.zoomLevel
        },
        (resp) => {
          this.$loading(false)
          this.list = resp.list
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    onZoom(zoomLevel) {
      this.zoomLevel = zoomLevel
      this.lazyLoad(this)
    },
    lazyLoad: debounce((vm) => {
      vm.getNearbyShop()
    }, 500),
    onCenter(latLng) {
      this.latLng = latLng
      this.lazyLoad(this)
    },
    onSetItem(val) {
      this.item = val
      this.show = true
    },
    goDetail() {
      this.$store.commit("shopInfo", this.item)
      this.$router.push(`/shop/details/${this.item.id}`)
    },
    goSearch() {
      this.$router.push("/shop")
    },
    goLocation() {
      // 对齐 App map.dart 定位按钮与 homeMap 时代实现：复用组件 onLocation()，
      // navigator.geolocation 获取当前位置 → 地图居中 + 位置标记 → emit center 触发商家列表刷新
      if (this.$refs.gmap) {
        this.$refs.gmap.onLocation()
      }
    },
    goScan() {
      // 对齐 home 底部 Scan 按钮：已登录 → 调起 H5 扫码，未登录 → 跳登录
      if (this.user && this.token) {
        this.isPickUpShow = true
      } else {
        this.$router.push("/login")
      }
    },
    onScanQr(qr) {
      this.isPickUpShow = false
      const arr = (qr || "").split("=")
      const qrode = arr[1] || arr[0]
      this.onScan(qrode)
    },
    onScan(qrcode) {
      this.$loading(true)
      this.$post(
        `${QR_CODE}?id=${qrcode}&usePriceUnit=true`,
        {},
        (resp) => {
          this.$loading(false)
          this.$store.commit("cabinet", {
            qrcode,
            ...resp
          })
          if (resp.zujieNum && resp.zujieNum > 0 && !resp.haveMifiBattery) {
            // confirm 组件挂载在 body 下，不在 .map-page 子树内，主题色需显式指定
            this.$confirm({
              title: this.i18nHome.msg_fail_title,
              content: `${this.i18nHome.msg_rentcount}`.format(resp),
              confirmText: this.i18nMsg.vieworder,
              cancelText: this.i18nMsg.cancel,
              confirmColor: "#FF8800"
            })
              .then(() => {
                this.$router.push("/order")
                this.$store.commit("qrcode", "")
              })
              .catch(() => {
                this.$store.commit("qrcode", "")
              })
          } else {
            this.$router.push("/home?cabinetshow=true")
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    }
  },
  created() {
    const { latitude, longitude } = this.$route.query
    if (latitude && longitude) {
      this.latLng = [+latitude, +longitude]
    }
    if (this.$route.query.qrcode) {
      this.onScan(this.$route.query.qrcode)
    }
    const { isScan } = this.$route.query
    if (isScan) {
      this.goScan()
    }
  },
  mounted() {}
}
</script>

<style lang="less" scoped>
.map-page {
  // 首页固定使用默认橙色主题，不跟随服务端下发的 themeIntValue；
  // 子树内的 var(--theme-color)（含 ScanQr 二维码描边）均继承此值
  --theme-color: #FF8800;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: var(--page-bg);
}

// 顶部 header：居中 logo（不再遮挡地图点击）
.map-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 30px 20px;
  // 防止遮挡地图点击
  pointer-events: none;
}

.map-header-logo {
  height: 50px;
  max-width: 50%;
  width: auto;
  display: block;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.35));
}

// 全屏 Google Map
.google-map {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1;
}

// 右下浮动按钮：搜索在上，定位在下（对齐 App map.dart L273-302）
// 两按钮均为深色半透明圆底；搜索图标黑色 PNG 需变白，定位 icon_locate.png 本身白色（透明底）不可加 filter
.map-fab-search,
.map-fab-gps {
  position: fixed;
  right: 30px;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);

  img {
    width: 48px;
    height: 48px;
    display: block;
  }
}

.map-fab-search img {
  // 黑色图标 → 白色
  filter: brightness(0) invert(1);
}

// 搜索按钮：顶部 28px（= App 16.w）间隔，位于 GPS 上方
.map-fab-search {
  bottom: 348px;
}

// 定位按钮：避开底部导航（BottomNav 总高约 180px）
.map-fab-gps {
  bottom: 230px;
}

// 底部导航：全屏地图上方悬浮（fixed），与右侧浮动按钮同层级；
// 组件自身 padding 20px 0 30px + inner 130px，总高约 180px
.map-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;
}

// shop-info 弹窗（点击地图 marker 时显示，位置避开底部导航）
.shop-info {
  position: fixed;
  bottom: 230px;
  left: 0;
  right: 0;
  z-index: 60;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  background: #fff;
  padding-bottom: 30px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);

  .shop-info-head {
    display: flex;
    padding: 20px 20px 0 20px;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    .shop-title {
      display: flex;
      justify-content: flex-start;
      flex-direction: row;
      align-items: center;

      h3 {
        padding: 0;
        margin: 0;
      }

      .shop-tag {
        margin-left: 20px;
        font-size: 24px;
        padding: 5px 15px;
        border: 1px solid #cacdd1;
        border-radius: 10px;
      }

      .shop-tag-active {
        color: var(--theme-color);
        border: 1px solid var(--theme-color);
      }
    }

    img {
      width: 60px;
      height: 60px;
    }
  }

  .shop-info-content {
    display: flex;
    padding: 0 20px;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    .shop-logo {
      width: 200px;

      img {
        max-height: 180px;
        max-width: 200px;
      }
    }

    .shop-detail {
      margin-left: 14px;

      .shop-time {
        margin: 15px 0;
        font-size: 22px;
        line-height: 30px;

        .time {
          padding: 4px 0;
          position: relative;
          padding-left: 10px;
          display: flex;
          flex-direction: row;
          align-items: center;

          img {
            display: inline-block;
            width: 30px;
            height: 30px;
            margin-right: 8px;
          }
        }
      }

      .shop-op {
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
        align-items: center;

        .return-num {
          margin-left: 20px;
          padding: 5px 10px;
          border: 1px solid var(--theme-color);
          border-radius: 10px;
          color: var(--theme-color);
        }

        .free-num {
          padding: 5px 10px;
          border: 1px solid var(--theme-color);
          border-radius: 10px;
          color: var(--theme-color);
        }
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: height 0.5s;
}
.fade-enter,
.fade-leave-to {
  height: 0;
}

// 扫码组件全屏遮罩
.map-pickup {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 200;
  background: rgba(0, 0, 0, 0.5);
}
</style>
